import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QRecordDetailsRFC extends QRFC {
  constructor() {
    super();
  }

  InitDetailsQuery(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true); // eh?
  }

  GetCallName() {
    return "qdetailsrfc";
  }

  SetParams(org, user, mode, data) {
    this.AddParameter("org", org);
    this.AddParameter("user", user);
    this.AddParameter("mode", mode);
    this.AddParameter("data", JSON.stringify(data));
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    if (r["success"]) {
      switch (r["mode"]) {
        case "enumeratedTable":
          var layout = this.fLayout; // layout belonging to a table
          layout.fDeferredTableLoad = true; // hmm...
          try {
            callBackObj.SetRecordDetails(r["tableName"], r["tableData"], layout);
          } catch (err) {
            layout.fDeferredTableLoad = false;
            console.log("setRecordDetails failure.");
          }

          break;
        default:
          console.log("mode problem");
      }
    } else {
      var anAlert = new QAlert();
      anAlert.InitCodeAlert(
        "Details Pull Unsuccessful",
        "Failed to get record details. Refresh Chart from data source before adding tables.",
        Globals._wsMgr.fBackgroundPanel,
        Globals._wsMgr
      );
    }

    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();

    if (this.fSCID != null) {
      var sc = Globals._wsMgr.GetSubChartMgr().FindSubChart(this.fSCID);
      if (sc != null) {
        sc.fPageLoaded = true;
      }
    }
  }
}
